var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import CapitalSocialContainer from '@/modules/search/containers/filterPanels/PortePanel/CapitalSocial.container.vue';
import FilialContainer from '@/modules/search/containers/filterPanels/PortePanel/Filial.container.vue';
import EmployeesContainer from '@/modules/search/containers/filterPanels/PortePanel/Employees.container.vue';
import RevenueContainer from '@/modules/search/containers/filterPanels/PortePanel/Revenue.container.vue';
let PortePanel = class PortePanel extends Vue {
};
__decorate([
    Prop({ default: () => [] })
], PortePanel.prototype, "filters", void 0);
PortePanel = __decorate([
    Component({
        name: 'PortePanel',
        components: {
            CapitalSocialContainer,
            FilialContainer,
            EmployeesContainer,
            RevenueContainer,
        },
    })
], PortePanel);
export default PortePanel;
